
    import '/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-process.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-approval-process-demo-end","docs-flow-components-approval-process-demo-processing"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/flow-components/approval-process.md?type=demo')
};